import { render, staticRenderFns } from "./CRMAllDetail.vue?vue&type=template&id=2d59ceca&scoped=true"
import script from "./CRMAllDetail.vue?vue&type=script&lang=js"
export * from "./CRMAllDetail.vue?vue&type=script&lang=js"
import style0 from "./CRMAllDetail.vue?vue&type=style&index=0&id=2d59ceca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d59ceca",
  null
  
)

export default component.exports